<div>
  <vip-paginator
    [paginator]="guestService.paginator"
    [requesting]="guestService.loading"
    (pageChanged)="setPaginator($event)"
  ></vip-paginator>
  <div [ngStyle]="{ 'background-color': '#ffffff', 'padding': '12px' }">
    <div class="row">
      <div class="list-flex">
        <div class="flex-item">
          <text-filter
            placeHolder="Name"
            (textChange)="filterGuests($event)"
          ></text-filter>
        </div>
        @if (permissionsService.user.additional_guests > 0) {
          <div class="flex-item" [ngStyle]="{ 'align-self': 'flex-end'}">
            <raised-button
              [styles]="{ float: 'right', width: '100%' }"
              (click)="openCreateGuestDialog()"
              color="primary"
              >
              Create Guest
            </raised-button>
          </div>
        }
      </div>
    </div>
  </div>
  <div [ngStyle]="{ overflow: 'auto' }">
    <div class="row">
      <cdk-table-component
        [displayColumns]="displayColumns"
        [entities]="tableEntities"
        [dataSource]="dataSource"
        (rowClickAction)="goToGuest($event)"
      ></cdk-table-component>
    </div>
  </div>
</div>
